(function () {
  'use strict';

  function normalizeText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function createAccordion(label, nodes, modifier, subtitle) {
    var details = document.createElement('details');
    details.className = 'pump-pdp-accordion' + (modifier ? ' ' + modifier : '');

    var summary = document.createElement('summary');
    summary.className = 'pump-pdp-accordion__summary';

    var labelSpan = document.createElement('span');
    labelSpan.className = 'pump-pdp-accordion__label';
    labelSpan.textContent = label;

    if (subtitle) {
      var subtitleSpan = document.createElement('span');
      subtitleSpan.className = 'pump-pdp-accordion__subtitle';
      subtitleSpan.textContent = subtitle;
      labelSpan.appendChild(subtitleSpan);
    }

    var hint = document.createElement('span');
    hint.className = 'pump-pdp-accordion__hint';
    hint.textContent = 'Click to expand';
    hint.setAttribute('aria-hidden', 'true');

    var icon = document.createElement('span');
    icon.className = 'pump-pdp-accordion__icon';
    icon.setAttribute('aria-hidden', 'true');

    var content = document.createElement('div');
    content.className = 'pump-pdp-accordion__content';

    nodes.forEach(function (node) {
      content.appendChild(node);
    });

    summary.appendChild(labelSpan);
    summary.appendChild(hint);
    summary.appendChild(icon);
    details.appendChild(summary);
    details.appendChild(content);

    details.addEventListener('toggle', function () {
      hint.textContent = details.open ? 'Click to collapse' : 'Click to expand';
    });

    return details;
  }

  function isTopLevelBoundary(node) {
    if (!node || node.nodeType !== 1) return false;
    return (
      node.tagName === 'H2' ||
      node.classList.contains('size-spec-box') ||
      node.classList.contains('product-right-setup')
    );
  }

  function collectSectionNodes(heading) {
    var nodes = [];
    var current = heading.nextSibling;

    while (current && !isTopLevelBoundary(current)) {
      var next = current.nextSibling;
      nodes.push(current);
      current = next;
    }

    return nodes;
  }

  function wrapFeatureSection(root) {
    var headings = Array.prototype.slice.call(root.children).filter(function (el) {
      return el.tagName === 'H2' && /pump features/i.test(normalizeText(el.textContent));
    });

    headings.forEach(function (heading) {
      if (heading.closest('.pump-pdp-accordion')) return;

      var nodes = collectSectionNodes(heading);
      if (!nodes.length) return;

      var accordion = createAccordion('Pump Features', nodes, 'pump-pdp-accordion--features');
      heading.replaceWith(accordion);
    });
  }

  function injectHydroXtremeOptionStyles() {
    if (document.getElementById('pump-hydroxtreme-options-styles')) return;

    var style = document.createElement('style');
    style.id = 'pump-hydroxtreme-options-styles';

    style.textContent = `
      .pump-hx-options {
        margin: 30px 0 32px;
      }

      .pump-hx-options__heading {
        margin: 0 0 8px !important;
        color: #2b2f33 !important;
        font-size: 22px !important;
        line-height: 1.2 !important;
        font-weight: 750 !important;
        text-transform: uppercase;
      }

      .pump-hx-options__heading::after {
        content: "";
        display: block;
        width: 100%;
        max-width: none;
        height: 2px;
        margin-top: 12px;
        background: #1686d9;
      }

      .pump-hx-options__intro {
        margin: 0 0 18px !important;
        color: #4a5056;
        font-size: 16px !important;
        line-height: 1.6 !important;
      }

      .pump-hx-options__grid {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 16px;
        align-items: stretch;
      }

      .pump-hx-option-card {
        position: relative;
        min-width: 0;
        padding: 22px 22px 20px;
        border: 1px solid #d5dde5;
        border-radius: 10px;
        background: #ffffff;
        box-shadow: 0 4px 14px rgba(22, 48, 72, 0.06);
      }

      .pump-hx-option-card--core {
        border-top: 4px solid #1686d9;
      }

      .pump-hx-option-card--full {
        border-top: 4px solid #ff7a00;
        background: #fbfcfe;
      }

      .pump-hx-option-card__eyebrow {
        display: block;
        margin: 0 0 10px;
        padding: 0;
        border-radius: 0;
        background: transparent;
        color: #1686d9;
        font-size: 13px;
        line-height: 1.2;
        font-weight: 800;
        letter-spacing: .055em;
        text-transform: uppercase;
      }

      .pump-hx-option-card--full .pump-hx-option-card__eyebrow {
        background: transparent;
        color: #e66f00;
      }

      .pump-hx-option-card__title {
        margin: 0 0 12px !important;
        color: #252a2f !important;
        font-size: 19px !important;
        line-height: 1.25 !important;
        font-weight: 750 !important;
        text-transform: none !important;
      }

      .pump-hx-option-card__desc {
        margin: 0 0 16px !important;
        color: #4b535a;
        font-size: 16px !important;
        line-height: 1.6 !important;
      }

      .pump-hx-option-card__includes {
        margin: 14px 0 10px;
        padding-top: 13px;
        border-top: 1px solid #e2e8ee;
        color: #69747d;
        font-size: 16px !important;
        line-height: 1.35;
        font-weight: 700;
        letter-spacing: .015em;
        text-transform: uppercase;
      }

      .pump-hx-option-card__list {
        display: grid;
        gap: 10px;
        margin: 0 !important;
        padding: 0 !important;
        list-style: none !important;
      }

      .pump-hx-option-card__list li {
        position: relative;
        margin: 0 !important;
        padding: 0 0 0 30px !important;
        color: #2f353a;
        font-size: 16px !important;
        line-height: 1.5 !important;
        list-style: none !important;
      }

      .pump-hx-option-card__list li::before {
        content: "✓";
        position: absolute;
        left: 0;
        top: 3px;

        display: flex;
        align-items: center;
        justify-content: center;

        width: 18px;
        height: 18px;

        border: 1px solid #1686d9;
        border-radius: 4px;

        background: #f1f8fd;
        color: #1686d9;

        font-size: 12px;
        line-height: 1;
        font-weight: 800;
      }

      .pump-hx-option-card--full .pump-hx-option-card__list li::before {
        border-color: #ff7a00;
        background: #fff6ed;
        color: #ff7a00;
      }

      @media (max-width: 798px) {
        .pump-hx-options {
          margin: 26px 0 28px;
        }

        .pump-hx-options__heading {
          font-size: 19px !important;
        }

        .pump-hx-options__intro {
          font-size: 15px !important;
        }

        .pump-hx-options__grid {
          grid-template-columns: 1fr;
          gap: 12px;
        }

        .pump-hx-option-card {
          padding: 19px 17px 18px;
        }

        .pump-hx-option-card__title {
          font-size: 18px !important;
        }

        .pump-hx-option-card__desc,
        .pump-hx-option-card__list li,
        .pump-hx-option-card__includes {
          font-size: 15px !important;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function cleanKitItem(value) {
    return normalizeText(value)
      .replace(/^[-•✓]+\s*/, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function transformHydroXtremeOptions(root) {
    var headings = Array.prototype.slice.call(root.children).filter(function (el) {
      return el.tagName === 'H2' && /options\s*:\s*pump only or full kit/i.test(normalizeText(el.textContent));
    });

    headings.forEach(function (heading) {
      if (heading.dataset.pumpHxOptionsReady === 'true') return;

      var nodes = [];
      var current = heading.nextElementSibling;

      while (current && current.tagName !== 'H2') {
        nodes.push(current);
        current = current.nextElementSibling;
      }

      if (!nodes.length) return;

      var intro = nodes.find(function (el) {
        return el.tagName === 'P' && normalizeText(el.textContent);
      });

      var pumpHeading = nodes.find(function (el) {
        return el.tagName === 'H5' && /pump only/i.test(normalizeText(el.textContent));
      });

      var fullHeading = nodes.find(function (el) {
        return el.tagName === 'H5' && /full hydroxtreme kit/i.test(normalizeText(el.textContent));
      });

      if (!pumpHeading || !fullHeading) return;

      function nextTextParagraph(startNode) {
        var el = startNode.nextElementSibling;
        while (el && el.tagName !== 'H5' && el.tagName !== 'H2') {
          if (el.tagName === 'P' && normalizeText(el.textContent)) return el;
          el = el.nextElementSibling;
        }
        return null;
      }

      var pumpDesc = nextTextParagraph(pumpHeading);
      var fullDesc = nextTextParagraph(fullHeading);

      var existingList = nodes.find(function (el) {
        return el.tagName === 'UL' || el.tagName === 'OL' || el.classList.contains('kit-includes-box');
      });

      var listItems = [];
      if (existingList) {
        var candidates = existingList.matches('ul,ol')
          ? existingList.querySelectorAll('li')
          : existingList.querySelectorAll('li');
        Array.prototype.forEach.call(candidates, function (li) {
          var item = cleanKitItem(li.textContent);
          if (item) listItems.push(item);
        });
      }

      if (!listItems.length) {
        listItems = [
          'HydroXtreme Penis Pump',
          'Patented Handball Pump w/Hose (removable)',
          'Comfort Insert Pad',
          'Bathmate Shower Strap / Measuring Gauge',
          'Custom Cleaning Sponge',
          'Bathmate Clean',
          'Wash Towel',
          'Premium Storage Case',
          'Security Lock'
        ];
      }

      var coreMatchers = [
        /hydroxtreme.*penis pump/i,
        /handball pump/i,
        /comfort insert/i
      ];

      var extraItems = listItems.filter(function (item) {
        return !coreMatchers.some(function (re) { return re.test(item); });
      });

      var modelMatch = normalizeText(heading.textContent).match(/HydroXtreme\s+([\w\s]+?)\s+Options/i);
      var modelName = modelMatch ? ('HydroXtreme ' + normalizeText(modelMatch[1])) : 'HydroXtreme';

      var section = document.createElement('section');
      section.className = 'pump-hx-options';

      var newHeading = document.createElement('h2');
      newHeading.className = 'pump-hx-options__heading';
      newHeading.textContent = modelName + ' Options';

      var newIntro = document.createElement('p');
      newIntro.className = 'pump-hx-options__intro';
      newIntro.textContent = 'Choose the core pump system or the complete accessory kit.';

      var grid = document.createElement('div');
      grid.className = 'pump-hx-options__grid';

      function makeCard(type, eyebrow, title, desc, items, includesLabel) {
        var card = document.createElement('div');
        card.className = 'pump-hx-option-card pump-hx-option-card--' + type;

        var eye = document.createElement('div');
        eye.className = 'pump-hx-option-card__eyebrow';
        eye.textContent = eyebrow;

        var h3 = document.createElement('h3');
        h3.className = 'pump-hx-option-card__title';
        h3.textContent = title;

        var p = document.createElement('p');
        p.className = 'pump-hx-option-card__desc';
        p.textContent = desc;

        card.appendChild(eye);
        card.appendChild(h3);
        card.appendChild(p);

        if (includesLabel) {
          var label = document.createElement('div');
          label.className = 'pump-hx-option-card__includes';
          label.textContent = includesLabel;
          card.appendChild(label);
        }

        var ul = document.createElement('ul');
        ul.className = 'pump-hx-option-card__list';
        items.forEach(function (itemText) {
          var li = document.createElement('li');
          li.textContent = itemText;
          ul.appendChild(li);
        });
        card.appendChild(ul);

        return card;
      }

      var pumpDescription = pumpDesc
        ? normalizeText(pumpDesc.textContent)
        : 'The essential HydroXtreme pumping system for users who already have the accessories they need.';

      var fullDescription = fullDesc
        ? normalizeText(fullDesc.textContent)
        : 'The complete HydroXtreme setup with accessories for use, cleaning, maintenance, and storage.';

      grid.appendChild(
        makeCard(
          'core',
          'Core System',
          'Pump Only',
          pumpDescription,
          [modelName + ' pump', 'Removable handball pump', 'Comfort insert pad'],
          'Includes'
        )
      );

      grid.appendChild(
        makeCard(
          'full',
          'Complete Setup',
          'Full HydroXtreme Kit',
          fullDescription,
          extraItems,
          'Everything in Pump Only, plus'
        )
      );

      section.appendChild(newHeading);
      section.appendChild(newIntro);
      section.appendChild(grid);

      heading.parentNode.insertBefore(section, heading);

      heading.remove();
      nodes.forEach(function (node) { node.remove(); });
      section.dataset.pumpHxOptionsReady = 'true';
    });
  }


  function moveBenefitsAfterSizeSpecs(root) {
    var sizeBox = root.querySelector(':scope > .size-spec-box');
    if (!sizeBox) return;

    var benefitsHeading = Array.prototype.slice.call(root.children).find(function (el) {
      return el.tagName === 'H2' && /benefits of using/i.test(normalizeText(el.textContent));
    });

    if (!benefitsHeading) return;

    var benefitNodes = collectSectionNodes(benefitsHeading);
    var parent = sizeBox.parentNode;
    var insertBeforeNode = sizeBox.nextSibling;

    parent.insertBefore(benefitsHeading, insertBeforeNode);
    benefitNodes.forEach(function (node) {
      parent.insertBefore(node, insertBeforeNode);
    });
  }


  function injectPumpBenefitStyles() {
    if (document.getElementById('pump-benefit-grid-styles')) return;

    var style = document.createElement('style');
    style.id = 'pump-benefit-grid-styles';

    style.textContent = `
      .pump-benefits-grid {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 14px;
        margin: 22px 0 30px;
      }

      .pump-benefit-card {
        position: relative;
        min-width: 0;
        padding: 18px 18px 18px 52px;
        border: 1px solid #dbe3ea;
        border-radius: 8px;
        background: #ffffff;
        box-shadow: 0 2px 8px rgba(25, 50, 75, 0.035);
        box-sizing: border-box;
      }

      .pump-benefit-card:last-child:nth-child(odd) {
        grid-column: 1 / -1;
      }

      .pump-benefit-card::before {
        content: "✓";
        position: absolute;
        left: 18px;
        top: 20px;

        display: flex;
        align-items: center;
        justify-content: center;

        width: 22px;
        height: 22px;

        border: 1px solid #1686d9;
        border-radius: 5px;

        background: #f1f8fd;
        color: #1686d9;

        font-size: 13px;
        line-height: 1;
        font-weight: 800;
      }

      .pump-benefit-card__title {
        display: block;
        margin: 0 0 6px;
        color: #2b2f33;
        font-size: 16px;
        line-height: 1.3;
        font-weight: 750;
      }

      .pump-benefit-card__text {
        margin: 0 !important;
        color: #4b535a;
        font-size: 16px !important;
        line-height: 1.6 !important;
      }

      @media (hover: hover) {
        .pump-benefit-card:hover {
          border-color: #c7d7e4;
          box-shadow: 0 4px 12px rgba(25, 50, 75, 0.055);
        }
      }

      @media (max-width: 767px) {
        .pump-benefits-grid {
          grid-template-columns: 1fr;
          gap: 10px;
          margin: 18px 0 26px;
        }

        .pump-benefit-card,
        .pump-benefit-card:last-child:nth-child(odd) {
          grid-column: auto;
        }

        .pump-benefit-card {
          padding: 16px 16px 16px 48px;
        }

        .pump-benefit-card::before {
          left: 16px;
          top: 18px;
          width: 20px;
          height: 20px;
          font-size: 12px;
        }

        .pump-benefit-card__title,
        .pump-benefit-card__text {
          font-size: 15px !important;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function transformBenefitsSection(root) {
    var heading = Array.prototype.slice.call(root.children).find(function (el) {
      return el.tagName === 'H2' && /benefits of using/i.test(normalizeText(el.textContent));
    });

    if (!heading || heading.dataset.pumpBenefitsReady === 'true') return;

    var nodes = collectSectionNodes(heading);

    var oldList = nodes.find(function (el) {
      return el.nodeType === 1 && (el.tagName === 'UL' || el.tagName === 'OL');
    });

    var existingGrid = nodes.find(function (el) {
      return el.nodeType === 1 && el.classList && el.classList.contains('pump-benefits-grid');
    });

    if (existingGrid) {
      heading.dataset.pumpBenefitsReady = 'true';
      return;
    }

    /*
     * SEO rule: JavaScript does not create the benefit copy.
     * Benefits must already exist in the server-rendered HTML. This function
     * only converts the existing list into the visual card layout.
     */
    if (!oldList) return;

    var sourceItems = Array.prototype.slice.call(oldList.querySelectorAll('li'));
    if (!sourceItems.length) return;

    var grid = document.createElement('div');
    grid.className = 'pump-benefits-grid';

    sourceItems.forEach(function (sourceItem) {
      var titleEl = sourceItem.querySelector('strong, b');
      var titleText = titleEl ? normalizeText(titleEl.textContent).replace(/:\s*$/, '') : '';

      var textClone = sourceItem.cloneNode(true);
      var clonedTitle = textClone.querySelector('strong, b');
      if (clonedTitle) clonedTitle.remove();
      var bodyText = normalizeText(textClone.textContent).replace(/^:\s*/, '');

      if (!titleText) {
        var raw = normalizeText(sourceItem.textContent);
        var colonIndex = raw.indexOf(':');
        if (colonIndex > -1) {
          titleText = raw.slice(0, colonIndex).trim();
          bodyText = raw.slice(colonIndex + 1).trim();
        } else {
          titleText = raw;
          bodyText = '';
        }
      }

      var card = document.createElement('div');
      card.className = 'pump-benefit-card';

      var title = document.createElement('strong');
      title.className = 'pump-benefit-card__title';
      title.textContent = titleText;
      card.appendChild(title);

      if (bodyText) {
        var text = document.createElement('p');
        text.className = 'pump-benefit-card__text';
        text.textContent = bodyText;
        card.appendChild(text);
      }

      grid.appendChild(card);
    });

    oldList.replaceWith(grid);
    heading.dataset.pumpBenefitsReady = 'true';
  }

  function transformSetupSection(root) {
    var setup = root.querySelector(':scope > .product-right-setup');
    if (!setup || setup.dataset.pumpAccordionReady === 'true') return;

    setup.dataset.pumpAccordionReady = 'true';

    var children = Array.prototype.slice.call(setup.children);
    var heading = children.find(function (el) { return el.tagName === 'H2'; });
    var usageHeading = children.find(function (el) {
      return el.tagName === 'H5' && /recommended usage/i.test(normalizeText(el.textContent));
    });

    var headingIndex = heading ? children.indexOf(heading) : -1;
    var usageIndex = usageHeading ? children.indexOf(usageHeading) : -1;

    var compareNodes;
    var usageNodes = [];

    if (usageIndex > -1) {
      compareNodes = children.slice(headingIndex + 1, usageIndex);
      usageNodes = children.slice(usageIndex + 1);
    } else {
      compareNodes = children.slice(headingIndex + 1);
    }

    setup.innerHTML = '';
    setup.classList.add('product-right-setup--accordions', 'product-right-setup--utility-grid');

    if (compareNodes.length) {
      setup.appendChild(
        createAccordion(
          'Compare Sizes & Models',
          compareNodes,
          'pump-pdp-accordion--compare',
          'Find the closest Bathmate fit'
        )
      );
    }

    if (usageNodes.length) {
      setup.appendChild(
        createAccordion(
          'Recommended Usage',
          usageNodes,
          'pump-pdp-accordion--usage',
          'Session time and pumping guidance'
        )
      );
    }
  }


  function getPumpSizeSpec() {
    var pathParts = window.location.pathname.replace(/\/$/, '').split('/');
    var handle = pathParts[pathParts.length - 1].toLowerCase();

    var specs = {
      'bathmate-hydromax-3':            { lengthIn: '1–3', lengthCm: '2.5–7.5', girthIn: 6,   girthCm: '15.5' },
      'bathmate-hydroxtreme-3':         { lengthIn: '1–3', lengthCm: '2.5–7.5', girthIn: 6,   girthCm: '15.5' },
      'bathmate-hydromax-5':            { lengthIn: '3–5', lengthCm: '7.5–12.5', girthIn: 6,   girthCm: '15.5' },
      'bathmate-hydroxtreme-5':         { lengthIn: '3–5', lengthCm: '7.5–12.5', girthIn: 6,   girthCm: '15.5' },
      'bathmate-hydromax-6':            { lengthIn: '4–6', lengthCm: '10–15',    girthIn: 6.5, girthCm: '16.5' },
      'bathmate-hydroxtreme-6':         { lengthIn: '4–6', lengthCm: '10–15',    girthIn: 6.5, girthCm: '16.5' },
      'bathmate-hydro-7':               { lengthIn: '5–7', lengthCm: '12.5–17.5',girthIn: 6.5, girthCm: '16.5' },
      'bathmate-hydromax-7':            { lengthIn: '5–7', lengthCm: '12.5–17.5',girthIn: 6.5, girthCm: '16.5' },
      'bathmate-hydroxtreme-7':         { lengthIn: '5–7', lengthCm: '12.5–17.5',girthIn: 6.5, girthCm: '16.5' },
      'bathmate-hydromax-7-wide-boy':   { lengthIn: '5–7', lengthCm: '12.5–17.5',girthIn: 7.5, girthCm: '19' },
      'bathmate-hydroxtreme-7-wide-boy':{ lengthIn: '5–7', lengthCm: '12.5–17.5',girthIn: 7.5, girthCm: '19' },
      'bathmate-hydromax-8':            { lengthIn: '6–8', lengthCm: '15–20',    girthIn: 7,   girthCm: '17.5' },
      'bathmate-hydroxtreme-8':         { lengthIn: '6–8', lengthCm: '15–20',    girthIn: 7,   girthCm: '17.5' },
      'bathmate-hydromax-9':            { lengthIn: '7–9', lengthCm: '17.5–22',  girthIn: 7.5, girthCm: '19' },
      'bathmate-hydroxtreme-9':         { lengthIn: '7–9', lengthCm: '17.5–22',  girthIn: 7.5, girthCm: '19' },
      'bathmate-hydroxtreme-11':        { lengthIn: '9–11',lengthCm: '23–28',    girthIn: 8.5, girthCm: '21.5' }
    };

    return specs[handle] || null;
  }

  function enhanceSizeSpecs(root) {
    var spec = getPumpSizeSpec();
    if (!spec) return;

    var boxes = root.querySelectorAll('.size-spec-box');

    Array.prototype.forEach.call(boxes, function (box) {
      if (box.dataset.pumpSizeSpecsReady === 'true') return;

      var paragraph = box.querySelector('p');
      if (!paragraph) return;

      var text = normalizeText(paragraph.textContent);
      var metrics = document.createElement('div');
      metrics.className = 'pump-size-metrics';

      function addMetric(label, value) {
        var item = document.createElement('div');
        item.className = 'pump-size-metric';

        var labelEl = document.createElement('span');
        labelEl.className = 'pump-size-metric__label';
        labelEl.textContent = label;

        var valueEl = document.createElement('span');
        valueEl.className = 'pump-size-metric__value';
        valueEl.textContent = value;

        item.appendChild(labelEl);
        item.appendChild(valueEl);
        metrics.appendChild(item);
      }

      var diameterIn = (spec.girthIn / Math.PI).toFixed(2);
      var diameterCm = ((spec.girthIn / Math.PI) * 2.54).toFixed(2);

      addMetric(
        'Recommended erect length',
        spec.lengthIn + ' in / ' + spec.lengthCm + ' cm'
      );
      addMetric(
        'Maximum girth',
        spec.girthIn + ' in / ' + spec.girthCm + ' cm'
      );
      addMetric(
        'Approx. diameter',
        diameterIn + ' in / ' + diameterCm + ' cm'
      );

      paragraph.parentNode.insertBefore(metrics, paragraph);
      box.classList.add('pump-size-specs-enhanced');
      box.dataset.pumpSizeSpecsReady = 'true';

      /*
       * The first sentence contains the measurement data now displayed
       * in the three standardized cards above. Keep the useful explanatory
       * sentence(s) underneath. Decimal points are protected by requiring
       * the next sentence to begin with a capital letter.
       */
      var sentenceEnd = text.search(/\.(?=\s+[A-Z])/);
      if (sentenceEnd > -1) {
        var remaining = text.slice(sentenceEnd + 1).trim();
        if (remaining) paragraph.textContent = remaining;
      }
    });
  }

  function markSecondaryHeadings(root) {
    Array.prototype.slice.call(root.children).forEach(function (el) {
      if (el.tagName !== 'H2') return;

      var text = normalizeText(el.textContent);
      if (/^who is .* best for\??$/i.test(text) || /^benefits of using /i.test(text)) {
        el.classList.add('pump-pdp-secondary-heading');
      }
    });
  }

  function initPumpPdpAccordions() {
    var root = document.querySelector('.product-below-content.pump-pdp-enhanced .rte');
    if (!root || root.dataset.pumpAccordionsReady === 'true') return;

    document.documentElement.classList.add('pump-pdp-page');
    root.dataset.pumpAccordionsReady = 'true';

    markSecondaryHeadings(root);
    injectHydroXtremeOptionStyles();
    injectPumpBenefitStyles();
    enhanceSizeSpecs(root);
    wrapFeatureSection(root);
    transformHydroXtremeOptions(root);
    moveBenefitsAfterSizeSpecs(root);
    transformBenefitsSection(root);
    transformSetupSection(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPumpPdpAccordions);
  } else {
    initPumpPdpAccordions();
  }

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(initPumpPdpAccordions, 0);
  });
})();
